import React from "react";
import OneStepTemplateCreation from "../../oneStepTemplateCreation/OneStepTemplateCreation";
import PresetsModalContent from "../presetsModal/PresetsModalContent";

interface NewFlowBuildTemplatesProps {
    flowId: number;
    templateBuildingWayId: number;
    onTemplatesCreated: () => void;
    completeFlow: () => void;
    onCancel: () => void;
    flowTriggerId: number;
}

const NewFlowBuildTemplates = ({ flowId, templateBuildingWayId, onTemplatesCreated, completeFlow, onCancel, flowTriggerId }: NewFlowBuildTemplatesProps) => {
    const onManualTemplateCreated = () => {
        onTemplatesCreated();
    }

    const onPresetsTemplatesCreated = () => {
        completeFlow();
    }

    return (
        <div className="flow-building-template-container">
            {templateBuildingWayId === 1 ? <div className="manual-container">
                <OneStepTemplateCreation onTemplateCreated={onManualTemplateCreated} onCancel={onCancel} flowId={flowId} flowTriggerId={flowTriggerId} />
            </div> : templateBuildingWayId === 2 ? <div className="presets-container">
                <PresetsModalContent isOpen={true} onClose={onPresetsTemplatesCreated} flowId={flowId} isFlowCreation={true} />
            </div> : null}
        </div>
    )
}

export default NewFlowBuildTemplates;